import React from 'react';
import {
  gridPageCountSelector,
  gridFilteredTopLevelRowCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { Select, MenuItem, Box, TablePagination } from '@mui/material';

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, (state) => state.pagination.paginationModel.page);
  const pageSize = useGridSelector(apiRef, (state) => state.pagination.paginationModel.pageSize);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const filteredRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);

  const handlePageChange = (event) => {
    const newPage = parseInt(event.target.value, 10);
    apiRef.current.setPage(newPage);
  };

  // Generează lista de pagini
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {pageCount > 1 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span style={{ fontSize: '13px', color: '#666' }}>Pagina:</span>
          <Select
            value={page}
            onChange={handlePageChange}
            size="small"
            sx={{ 
              minWidth: 60,
              height: 28,
              fontSize: '13px',
              '& .MuiSelect-select': {
                paddingTop: '4px',
                paddingBottom: '4px',
                paddingLeft: '8px',
                paddingRight: '24px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d0d0d0',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#999',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  '& .MuiMenuItem-root': {
                    fontSize: '13px',
                    minHeight: '32px',
                    paddingTop: '4px',
                    paddingBottom: '4px',
                  },
                },
              },
            }}
          >
            {pageOptions.map((pageNum) => (
              <MenuItem key={pageNum} value={pageNum}>
                {pageNum + 1}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
      <TablePagination
        component="div"
        count={filteredRowCount}
        page={page}
        rowsPerPage={pageSize}
        onPageChange={(event, newPage) => apiRef.current.setPage(newPage)}
        onRowsPerPageChange={(event) => apiRef.current.setPageSize(parseInt(event.target.value, 10))}
        rowsPerPageOptions={[10, 15, 20, 50, 100]}
        labelRowsPerPage="Rânduri pe pagină:"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
        sx={{
          '.MuiTablePagination-toolbar': {
            minHeight: '36px',
          },
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontSize: '13px',
            margin: 0,
          },
          '.MuiTablePagination-select': {
            fontSize: '13px',
          },
        }}
      />
    </Box>
  );
}

export default CustomPagination;
